<template>
    <div class="content-wrapper">
        <div class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <h1>
                            Corporation Information
                        </h1>
                    </div>
                </div>
            </div>
        </div>

        <div class="content">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <label for="">Account ID: </label> <span><strong>{{formBus.borrower_id}}</strong></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header">
                            <h5><strong>Basic Information</strong> </h5>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label for="" v-if="formBus.bt_code==='BT2020004'">Corporation Name</label>
                                        <label for="" v-if="formBus.bt_code==='BT2020002'">Partnership Name</label>
                                        <input type="text" name="corpName" v-model="formBus.business_name" id="corpName" class="form-control" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                    </div>

                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label v-if="formBus.bt_code==='BT2020004'">Incorporation Date</label>
                                        <label v-if="formBus.bt_code==='BT2020002'">Partnership Date</label>
                                        <input autocomplete="off" id="birthdate" name="birthdate" type="text" v-model="formBus.startdate" class="form-control" v-input-mask data-inputmask-alias="datetime" data-inputmask-inputformat="mm/dd/yyyy" @focus="" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header">
                            <h5><strong>Registered Address Information</strong></h5>
                        </div>
                        <form action="" role='form'>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Province</label><span class="danger fs-18 bold">&nbsp;*</span>
                                            <v-select label="province" :options="provinces" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" :reduce="province => province.province_code" v-model="formBus.province_code" :clearable="false" @input="getCity(formBus.province_code), formBus.city_code=''"></v-select>

                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">

                                            <label>City/Municipality</label><span class="danger fs-18 bold">&nbsp;*</span>
                                            <v-select label="city" :options="cities" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" :reduce="city => city.city_code" :clearable="false" v-model="formBus.city_code" @input="getBrgy(formBus.city_code), formBus.bcode=''"></v-select>

                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Barangay</label><span class="danger fs-18 bold">&nbsp;*</span>

                                            <v-select label="bname" :options="brgys" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" :reduce="bname => bname.bcode" :clearable="false" v-model="formBus.bcode"></v-select>

                                        </div>
                                    </div>
                                </div>
                                <div class="row">

                                    <div class="col-sm-4">
                                        <div class="form-group">

                                            <label>House No/Block & Lot/Building</label><span class="danger fs-18 bold">&nbsp;*</span>
                                            <input autocomplete="off" type="text" class="form-control text-uppercase" v-model="formBus.bldg" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">

                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">

                                            <label>Street Name / Subdivision</label><span class="danger fs-18 bold">&nbsp;*</span>
                                            <input autocomplete="off" type="text" class="form-control text-uppercase" v-model="formBus.street_address" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">

                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Ownership</label><span class="danger fs-18 bold">&nbsp;*</span>
                                            <select class="form-control custom-select text-uppercase" v-model="formBus.add_ship" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                                <option value="" selected disabled>Select Ownership</option>
                                                <option value="1">Owned</option>
                                                <option value="2">Rented</option>
                                                <option value="3">Living with parents</option>
                                                <option value="4">Living with relatives</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>
                            </div>


                        </form>
                    </div>
                </div>
            </div>
<!-- 
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header">
                            <h5><strong>Documentary Registration</strong></h5>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-6">
                                    <label for="">Secretary Certification</label>
                                    <div class="custom-file">
                                        <label for="" class="custom-file-label">Choose File</label>
                                        <input type="file" name="secCert" id="secCert" class="custom-file-input" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <label for="">SEC Registration</label>
                                    <div class="custom-file">
                                        <label for="" class="custom-file-label">Choose File</label>
                                        <input type="file" name="secReg" id="secReg" class="custom-file-input" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header">
                            <h5><strong>Employee Information</strong></h5>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                    <span> <strong>No. of paid employee as of December 31, 2019</strong> </span> <br>
                                    <span class="mt-4">Regular Employee</span><br>
                                    
                                        <input type="text" name="regEmp" id="regEmp" class="form-control" placeholder="Regular Employee" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <br>
                                        <span class="mt-4">Contractual Employee</span><br>
                                        <input type="text" name="conEmp" id="conEmp" class="form-control" placeholder="Contractual Employee" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <span> <strong>No. of paid employee as at time of loan</strong> </span> <br>
                                        <span class="mt-4">Regular Employee</span><br>
                                        <input type="text" name="regEmp" id="regEmp" class="form-control" placeholder="Regular Employee" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <br>
                                        <span class="mt-4">Contractual Employee</span><br>
                                        <input type="text" name="conEmp" id="conEmp" class="form-control" placeholder="Contractual Employee" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header">
                            <h5><strong>Financial Data</strong></h5>
                        </div>
                        <div class="card-body">
                            <!-- <div class="row">
                                <div class="col-sm-4">

                                    <label for="">Do you have a BIR-filed Financial Statements</label>
                                    <div class="row">
                                        <div class="col-sm-2">
                                            <input type="radio" name="bir" id="yes" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)"> Yes
                                        </div>
                                        <div class="col-sm-2">
                                            <input type="radio" name="bir" id="no" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)"> No
                                        </div>

                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <label for="">2019 BIR FS</label>
                                    <div class="custom-file">
                                        <label for="" class="custom-file-label">Choose File</label>
                                        <input type="file" name="bir2019" id="bir2019" class="custom-file-input" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <label for="">2018 BIR FS</label>
                                    <div class="custom-file">
                                        <label for="" class="custom-file-label">Choose File</label>
                                        <input type="file" name="bir2018" id="bir2018" class="custom-file-input" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                    </div>
                                </div>

                            </div> -->
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label for="">Asset Size</label>
                                        <input type="text" name="assetSize" id="assetSize" class="form-control" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)"> 
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label for="">Annual Sales</label>
                                        <input type="text" name="sales" id="sales" class="form-control" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import moment from 'moment'
    import {
        Form
    } from 'vform';
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    export default {
        data() {

            return {
                data_suffix: [],
                data_IDtypes: [],
                provinces: [],
                cities: [],
                brgys: [],
                readonly: true,
            
                user: new Form({
                    id: null,
                    email: null,
                    firstname: null,
                    lastname: null,
                    birthdate: null,
                    bus_type: null,
                    suffix_code: null,
                }),

                prereg: new Form({
                    user_id: null,
                    borrower_id: null,
                    step: 1,
                    completed: 0,
                }),

                formBus: new Form({
                    borrower_id: null,
                    bt_code: null,
                    business_name: null,
                    start_date: null,
                    bldg: null,
                    street_address: null,
                    bcode: null,
                    bname: null,
                    city_code: null,
                    city: null,
                    province_code: null,
                    province: null,
                    add_ship: null,
                    startdate: null,
                    owner_desc: null,
                })
            }
        },
        methods: {
            getBrgy(val) {
                axios.get('api/ref-city-brgy', {
                        params: {
                            city_code: val
                        }
                    })
                    .then(response => {
                        this.brgys = response.data;
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            },
            getBrgy() {
                axios.get('api/ref-city-brgy', {
                        params: {
                            city_code: this.formBus.city_code
                        }
                    })
                    .then(response => {
                        this.brgys = response.data;
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            },
            getCity(val) {
                axios.get('api/ref-prov-cities', {
                        params: {
                            province_code: val
                        }
                    })
                    .then(response => {
                        this.cities = response.data;
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            },
            getCity() {
                axios.get('api/ref-prov-cities', {
                        params: {
                            province_code: this.formBus.province_code
                        }
                    })
                    .then(response => {
                        this.cities = response.data;
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            },
            getProvince() {
                axios.get('/api/ref-provinces')
                    .then(response => {
                        this.provinces = response.data
                        this.getCity();
                        this.getBrgy();
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            getCorpProfile() {
                
                axios.get('api/get-corp-profile')
                    .then(response => {

                        this.formBus.fill(response.data[0])


                        let clientStartDate = moment(this.formBus.start_date, 'YYYY-MM-DD');
                        this.formBus.startdate = clientStartDate.format('MM/DD/YYYY');



                    })
            },
            getPrereg() {
                axios
                    .get("api/get-prereg")
                    .then(response => {
                        if (response.data.length > 0) {
                            this.prereg.fill(response.data);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            getInit() {
                axios
                    .get("api/user")
                    .then(response => {
                        this.user.fill(response.data);
                        if (this.user) {
                            this.getPrereg();
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },


        },
        created() {
            this.getCorpProfile();
            this.getPrereg();
            this.getInit();
            this.getProvince();
        }
    }
</script>